import { gql } from '@apollo/client/core';

export interface ContentRepository {
  id: string;
  name: string;
}

export interface ContentRepositoriesRes {
  allContentRepositories: ContentRepository[];
}

export const GET_CONTENT_REPOSITORIES = gql`
  query allContentRepositories {
    allContentRepositories {
      id
      name
    }
  }
`;

export interface ContentRepositoriesByOrgResponse {
  contentRepositories: ContentRepository[];
}

export const GET_CONTENT_REPOSITORIES_By_ORGANISATION = gql`
  query contentRepositories($organization: String!) {
    contentRepositories(organization: $organization) {
      id
      name
    }
  }
`;
